<template>
  <div v-if="offersData.offerList.length" class="label margin-bottom-m">
    <button
      :class="{
        purple: offersData.topOffer.isLoyallistOffer,
        red: !offersData.topOffer.isLoyallistOffer,
      }"
      class="h6 offer-badge badge heavy"
      type="button"
      name="button"
      @click="scrollIntoMembers"
    >
      Offers available—see below
    </button>
  </div>
</template>

<script setup>
import { getOffersData } from '@nuxt-common/media-card-large/app/modules/price/composables/utils.bcom';
import { useProduct } from '~/modules/product/composables/useProduct';

const { productData } = useProduct();

const badgeData = productData.pricing || {};

const offersData = getOffersData(badgeData, {});

const scrollIntoMembers = (e) => {
  /** @type {HTMLElement | null} */
  const membersOfMaster = document.getElementById('members-of-master');
  if (membersOfMaster) {
    e.target.blur();
    membersOfMaster.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }
};
</script>

<style lang="scss" scoped>
.offer-badge {
  margin: 0;
  padding: rem-calc(10 15);
  height: auto;
  background: $promotions-color;
  color: $dashboard-color;
  border: none;
  line-height: 1.5;
  text-align: left;
  min-height: rem-calc(18);
  cursor: pointer;
}

.badge {
  background: $background-color;
  padding: rem-calc(2 4);
  cursor: pointer;
}

.purple {
  color: $loyalty-primary-1-color;
}

.red {
  color: #d73312;
}
</style>
